import CardPostDetail from "components/CardPostDetail";
import Layout from "Layout";
import React from "react";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { useCallback } from "react";
import { getPencapaianById } from "services/apiRoutes";
import { useEffect } from "react";
import Slider from "react-slick";
import ArrowButton from "components/ArrowButton";
import SkeletonCapaian from "skeletons/SkeletonCapaian";
import SkeletonArticle from "skeletons/SkeletonArticle";

export default function PostPencapaian() {
   const settings = {
     dots: true,
     infinite: true,
     speed: 300,
     slidesToShow: 1,
     nextArrow: <ArrowButton right />,
     prevArrow: <ArrowButton />,
     dotsClass: "button__bar",
     slidesToScroll: 1,
   };

  const {slug,id} = useParams();
  const [post,setPost] = useState();

  const postAPI = useCallback(async (uuid)=>{
    const res = await getPencapaianById(uuid,slug);
    if (res.error) {
      return res.message;
    }else{
      const {data} = res.data;
      setPost(data);
    }
  },[slug]);

  useEffect(() => {postAPI(id)}, [postAPI,id]);

  return (
    <Layout>
      <div className="items-center px-5 xl:pt-56 pt-28 Pencapaian-wrapper xl:px-99">
        <h1 className="mb-12 text-2xl font-bold xl:text-7xl">{post?.nama}</h1>
        <div className="gap-5 mb-32 space-y-14 xl:grid lg:grid-cols-4 contentWrapper xl:space-y-0">
          <div className="col-span-3 postImage rounded-2xl ">
            <Slider {...settings}>
              {post ? (
                post.list_galeri_capaian_obj.map((item) => (
                  <div className="wrapper">
                    <img
                      key={item.uuid}
                      crossOrigin="anonymous"
                      src={item?.url_gambar}
                      alt={item.caption}
                      className="rounded-2xl"
                    />
                    <h1 className="mt-2 ml-2 text-lg font-normal text-center">
                      {item?.caption}
                    </h1>
                  </div>
                ))
              ) : (
                <SkeletonCapaian />
              )}
            </Slider>
          </div>
          <CardPostDetail
            share
            date={post?.tanggal}
            lokasi={post?.lokasi}
            waktu={post?.waktu}
          />
        </div>
        <div className="p-5 leading-6 border xl:p-10 rounded-2xl border-borderCardFeatures mb-28">
          {post ? (
            <div
              dangerouslySetInnerHTML={{
                __html: post ? post?.deskripsi : <SkeletonArticle />,
              }}
            />
          ) : (
            <SkeletonArticle />
          )}
          {/* <p className="text-justify text-articleTitle">
            {post ? post?.deskripsi : <SkeletonArticle />}
          </p> */}
        </div>
      </div>
    </Layout>
  );
}
